import React, { useEffect, useState } from "react";
import { Table } from "../../components/Table/Table";
import { useNavigate } from "react-router-dom";
import { useLazyLogListQuery, useLazyLogFilterQuery } from "../redux/api/api";
import { toast } from "react-toastify";
import CancelIcon from "@mui/icons-material/Cancel";
import DownloadingIcon from "@mui/icons-material/Downloading";
import { BASE_URL, URL } from "../redux/api/Constants";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import moment from "moment/moment";
import RefreshIcon from '@mui/icons-material/Refresh';

const DailyLog = () => {
    const navigate = useNavigate();
    const [popup, setPopup] = useState(false);
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState("");
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [userData, setUserData] = useState(null);
    const [date, setDate] = useState();
    const today = moment();
    const [max, setMax] = useState(today.clone().toDate());
    const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
    const [logFilter] = useLazyLogFilterQuery();

    const [loglistapi] = useLazyLogListQuery();

    const getList = () => {
        loglistapi()
            .unwrap()
            .then((res) => {
                setList(res.logs);
                setPagination(res.pagination_meta);
            })
            .catch((err) => {
                console.log(err);
                toast.error("Error fetching logs");
            });
    };

    useEffect(() => {
        if (givenpermissions?.includes("COMPANY-CAN-List-COMPANY_LOGS")) {
            getList();
        }
    }, []);

    const handleDownload = (date) => {
        try {
            const a = document.createElement("a");
            let params = `?date=${date}&download=true`
            a.href = `${BASE_URL + URL.LOG_FILE + params}`
            a.setAttribute('target', '_blank');
            a.download = `${date}.log`;
            a.click();
        } catch (error) {
            console.log('error', error);

        }
    };

    const handleFilterByDate = (date_) => {
        const formattedDate = moment(date_).format("YYYY-MM-DD");
        let params = `?date=${formattedDate}`
        logFilter(params)
            .unwrap()
            .then((res) => {
                setDate(date_);
                setList(res.logs);
                setPagination(res.pagination_meta);
            })
            .catch((err) => {
                console.log(err);
                toast.error("Error filtering logs by date");
            });
    };

    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => <p>{row.index + 1}</p>,
            },
            {
                Header: "Date",
                accessor: "date",
                Cell: ({ value }) => <p>{moment(value).format("DD-MM-YYYY")}</p>,
            },
            {
                Header: "Log File",
                accessor: "filename",
                Cell: ({ value }) => <p>{value}</p>,
            },
            {
                Header: "File Size (KB)",
                accessor: "size_kb",
                Cell: ({ value }) => <p>{value ? value : "--"}</p>,
            },
            {
                Header: "Permission",
                accessor: "is_writable",
                Cell: ({ value }) => <p>{value ? "Yes" : "No"}</p>,
            },
            {
                Header: "Download",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">
                                <button
                                    onClick={() => handleDownload(row.original.date)}
                                    className="cust-btn"
                                >
                                    <DownloadingIcon className="text-danger" />
                                </button>
                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );

    return (
        <div className="dashRightView home_section">
            <div className="d-flex ac-jb">
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                    Company Daily Logs
                </h2>

                <div className="d-flex ac-jc gap-2">
                    <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mt-3 primary ">
                        Date
                    </p>
                    <DatePicker
                        className={`f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-13 fs-xxl-22  primary`}
                        format="yyyy/MM/dd"
                        value={date}
                        max={max}
                        onChange={(e) => {
                            handleFilterByDate(e.target.value);
                        }}
                    />
                    <React.Fragment>
                        <div className="d-flex ac-jc">
                            <button
                                onClick={() => getList()}
                                className="cust-btn"
                            >
                                <RefreshIcon className="text-danger" />
                            </button>
                        </div>
                    </React.Fragment>
                </div>
            </div>

            {popup && (
                <div className="popup-design">
                    <div className="popup">
                        <div className="d-flex ac-jb">
                            <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                                View Log
                            </h2>
                            <button
                                onClick={() => {
                                    setPopup(false);
                                }}
                                className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
                            >
                                <CancelIcon />
                            </button>
                        </div>

                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Log Details
                        </h4>
                        <div>
                            <p>{userData?.email}</p>
                            <p>{userData?.name}</p>
                            <p>{userData?.phone}</p>
                        </div>
                    </div>
                </div>
            )}

            <Table
                columns={columns}
                data={list}
                show={true}
                pagecount={pagination}
                setPageno={(pageNo) => setPage(pageNo)}
            />
        </div>
    );
};


export default DailyLog